import { useAppSelector } from 'app/store';
import { BottomFromTechnicianCoordinatorRoles } from '../../constants';

export function isBottomFromTechnicianCoordinatorBoolean(): boolean {
  const groups = useAppSelector((state) => state.auth.groups);
  return groups?.some((role) => BottomFromTechnicianCoordinatorRoles.includes(role)) ?? false;
}
